import {
  accountColumnDefinition,
  bookTypeColumnDefinition,
  costCenterColumnDefinition,
  currencyColumnDefinition,
  descriptionColumnDefinition,
  enteredAmountColumnDefinition,
  enteredCurrencyColumnDefinition,
  geographyColumnDefinition,
  localAccountColumnDefinition,
  localAccountDescriptionColumnDefinition,
  preTaxColumnDefinition,
  productLineColumnDefinition,
  projectColumnDefinition,
  referenceColumnDefinition,
  tradingPartnerColumnDefinition,
  ytdBalanceColumnDefinition,
} from '../columnDefinitions';

export const trialBalanceColumnDefsTpc = [
  {
    ...localAccountColumnDefinition,
    headerName: 'Local Account',
    field: 'LOCAL_ACCOUNT',
  },
  {
    ...localAccountDescriptionColumnDefinition,
    headerName: 'Local Description',
    field: 'LOCAL_ACCOUNT_DESCRIPTION',
  },
  {
    ...accountColumnDefinition,
    headerName: 'Account',
    field: 'R2R_ACCOUNT',
  },
  {
    ...descriptionColumnDefinition,
    headerName: 'Description',
    field: 'R2R_DESCRIPTION',
  },
  {
    ...preTaxColumnDefinition,
    headerName: 'Pre Tax',
    field: 'preTaxFlag',
    valueGetter: params => params.data?.preTaxFlag ?? params.data?.PRE_TAX_FLAG ?? '',
    customExport: {
      getValueFromRow: row => row?.preTaxFlag ?? row?.PRE_TAX_FLAG ?? '',
    },
  },
  {
    ...currencyColumnDefinition,
    field: 'CURRENCY_CODE',
  },
  {
    ...ytdBalanceColumnDefinition,
    field: 'YTD_BALANCE',
  },
  {
    ...tradingPartnerColumnDefinition,
    headerName: 'Trading Partner',
    field: 'TRADING_PARTNER',
  },
  {
    ...bookTypeColumnDefinition,
    headerName: 'Book Type',
    field: 'BOOK_TYPE',
  },
  {
    ...costCenterColumnDefinition,
    headerName: 'Cost Center',
    field: 'COST_CENTER',
  },
  {
    ...geographyColumnDefinition,
    headerName: 'Geography',
    field: 'GEOGRAPHY',
  },
  {
    ...projectColumnDefinition,
    headerName: 'Project Code',
    field: 'PROJECT',
  },
  {
    ...referenceColumnDefinition,
    headerName: 'Reference',
    field: 'REFERENCE',
  },
  {
    ...productLineColumnDefinition,
    headerName: 'Product Line',
    field: 'PRODUCT_LINE',
  },
];

export const trialBalanceColumnDefsEsdrm = [
  {
    ...accountColumnDefinition,
    headerName: 'Account',
    field: 'R2R_ACCOUNT',
  },
  {
    ...descriptionColumnDefinition,
    headerName: 'Description',
    field: 'R2R_DESCRIPTION',
  },
  {
    ...preTaxColumnDefinition,
    headerName: 'Pre Tax',
    field: 'preTaxFlag',
    valueGetter: params => params.data?.preTaxFlag ?? params.data?.PRE_TAX_FLAG ?? '',
    customExport: {
      getValueFromRow: row => row?.preTaxFlag ?? row?.PRE_TAX_FLAG ?? '',
    },
  },
  {
    ...enteredCurrencyColumnDefinition,
    headerName: 'Entered Currency',
    field: 'ENTERED_CURRENCY_CODE',
  },
  enteredAmountColumnDefinition,
  {
    ...currencyColumnDefinition,
    field: 'CURRENCY_CODE',
  },
  {
    ...ytdBalanceColumnDefinition,
    field: 'YTD_BALANCE',
  },
  {
    ...bookTypeColumnDefinition,
    headerName: 'Book Type',
    field: 'BOOK_TYPE',
  },
  {
    ...tradingPartnerColumnDefinition,
    headerName: 'Trading Partner',
    field: 'TRADING_PARTNER',
  },
  {
    ...costCenterColumnDefinition,
    headerName: 'Cost Center',
    field: 'COST_CENTER',
  },
  {
    ...geographyColumnDefinition,
    headerName: 'Geography',
    field: 'GEOGRAPHY',
  },
  {
    ...projectColumnDefinition,
    headerName: 'Project Code',
    field: 'PROJECT',
  },
  {
    ...referenceColumnDefinition,
    headerName: 'Reference',
    field: 'REFERENCE',
  },
  {
    ...productLineColumnDefinition,
    headerName: 'Product Line',
    field: 'PRODUCT_LINE',
  },
];
